import { AnalyticsRequest, GroupBy, Sort } from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultPosition } from '../../PanelTemplatesTheme/constants';
import { Panel } from '../../../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';

export const TemplateHyperSpaceAreaChart: Panel = {
    id: 'hyper-space-area-chart',
    name: 'Area Chart',
    description: '',
    tags: ['Standard', 'Area Chart', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_area_chart',
        children: [
            {
                type: 'hyperSpaceAreaChart',
                id: 'hyper-space-area-chart',
                name: 'Area Chart',
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                analyticsRequests: [
                    new AnalyticsRequest({
                        limit: 2000,
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.day },
                                INBOUND_MESSAGE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'snCTm',
                                },
                                PLATFORM: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                BENCHMARKING: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                PAID: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'measurementTime',
                                },
                                ADVOCACY: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                RDB_FIREHOSE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'SN_CREATED_TIME',
                                },
                                STORY_MESSAGE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'CREATED_TIME',
                                },
                                UNIVERSAL_PROFILE: {
                                    dimensionName: 'SN_TYPE',
                                }
                            }),
                            new GroupBy({
                                LISTENING: {
                                    source: ListeningDimensions.topicName,
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                INBOUND_MESSAGE: {
                                    dimensionName: 'ACCOUNT_ID',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                PLATFORM: {
                                    dimensionName: 'ACCOUNT_ID',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                BENCHMARKING: {
                                    dimensionName: 'BRAND_ID',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                PAID: { dimensionName: 'accountIds', limitType: 'TOP', limit: 8 },
                                ADVOCACY: {
                                    dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                RDB_FIREHOSE: {
                                    dimensionName: 'RDB_QUERY_IDS',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                STORY_MESSAGE: {
                                    dimensionName: 'RDB_DATA_SOURCE',
                                    limitType: 'TOP',
                                    limit: 8,
                                },
                                UNIVERSAL_PROFILE: {
                                    dimensionName: 'GENDER',
                                }
                            }),
                        ],
                        sorts: [
                            new Sort({ order: 'DESC', projections: 0 }),
                            new Sort({ order: 'ASC', groupBys: 0 }),
                        ],
                        timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
                    }) as any,
                ],
                position: DefaultPosition,
                label: {
                    titleText: 'Area Chart',
                    size: WIDGET_LABEL_SIZE.primary,
                    enabled: false,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    baseXYChartOptions: {
                        grid: {
                            enabled: false,
                        },
                        xAxis: {
                            ticks: {
                                formats: {
                                    numberFormat: {
                                        decimals: 0,
                                        useShortened: true,
                                    },
                                    dateFormat: {
                                        autoFormat: true,
                                        formatString: 'dd MMM',
                                    },
                                },
                                numTicks: 5,
                            },
                            enabled: true,
                            label: {
                                enabled: true,
                                size: 50,
                            },
                            line: {
                                enabled: false,
                                stroke: '',
                                strokeWidth: 1,
                            },
                        },
                        yAxis: {
                            ticks: {
                                formats: {
                                    numberFormat: {
                                        decimals: 0,
                                        useShortened: true,
                                    },
                                    dateFormat: {
                                        autoFormat: true,
                                        formatString: 'dd MMM',
                                    },
                                },
                                //TODO: how should we actually handle this
                                numTicks: 5,
                            },
                            enabled: true,
                            label: {
                                enabled: true,
                                size: 50,
                            },
                            line: {
                                enabled: false,
                                stroke: '',
                                strokeWidth: 1,
                            },
                        },
                    },
                    zeroFill: true,
                    legend: {
                        enabled: true,
                        position: {
                            auto: true,
                            selectedPosition: 'top',
                        },
                    },
                },
            },
        ],
    },
};
